<app-header></app-header>

<div class="root">
	<app-upload-progress-header></app-upload-progress-header>
	<router-outlet></router-outlet>
</div>
